export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6398.6510f704.jpg";